import { AuthService } from './auth.service';
import { Injectable } from "@angular/core";
import { ReportType } from "../models/models.swagger.generated";

@Injectable({
  providedIn: 'root',
})
export class ReportVisibilityService {
  constructor(private authService: AuthService) {
  }

  public canUserSeeReport(reportType: ReportType): boolean {
    if (this.authService.isUserStandardUser()) {
      return reportType === ReportType.UserExtract || reportType === ReportType.ParkerExtract || reportType === ReportType.Payment;
    }
    if (reportType === ReportType.AutomaticParking && !this.authService.isUserAdmin()) {
      return false;
    }
    if (reportType === ReportType.UserExtract) {
      return false;
    }
    if (this.authService.isUserCompanyAdmin() && !(reportType === ReportType.ParkerTurnover 
      || reportType === ReportType.ParkerRegistrations 
      || reportType === ReportType.ParkerExtract)) {
      return false;
    }

    return true;
  }
}
